<template>
    <div class="badge-9-wrapper" :style="((widget_data.widget.settings.badge_display == 'Embed' ? 'margin: auto;': ''))">
        <v-card
            elevation="0"
            class="reviews-badge"
            @click="$parent.showDialog()"
            rounded
            outlined
            flat
            :style="'border-radius: 3px !important; padding-bottom: 0px; background-color: ' + ((widget_data.widget.settings.background_type == 'Transparent') ? 'transparent' : widget_data.widget.settings.background_color) + '; color: ' + widget_data.widget.settings.text_color + ';'"
        >
            <div class="clearfix p-3 pb-0 text-center">
                <div style="display: inline-block; position: relative;">
                    <div style="position: absolute; top: -12px; -webkit-transform: rotate(230deg); -moz-transform: rotate(230deg); -o-transform: rotate(230deg); -ms-transform: rotate(230deg); transform: rotate(230deg);"
                        :style="((widget_data.widget.settings.platforms.length == 1) ? 'left: -12px;' : 'left: -9px;')"
                        >
                        <svg class="media-object" width="46" height="46" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.17687 31.1719C7.27449 30.8126 7.05875 30.313 6.85285 29.9529C6.78874 29.8455 6.71919 29.7415 6.64449 29.6412C4.87857 26.9631 3.93735 23.8256 3.93746 20.6177C3.90875 11.4097 11.5442 3.9375 20.986 3.9375C29.2203 3.9375 36.0937 9.64195 37.6999 17.2143C37.9405 18.3369 38.0621 19.4819 38.0625 20.63C38.0625 29.8512 30.7215 37.4407 21.2797 37.4407C19.7785 37.4407 17.7523 37.0634 16.6474 36.7541C15.5424 36.4448 14.4391 36.0347 14.1545 35.9248C13.8633 35.8129 13.5541 35.7553 13.2423 35.755C12.9016 35.7537 12.5642 35.8215 12.2505 35.9543L6.68633 37.9624C6.56443 38.015 6.43526 38.0487 6.30324 38.0625C6.19906 38.0622 6.09597 38.0412 5.99996 38.0008C5.90394 37.9603 5.81691 37.9012 5.74389 37.8269C5.67087 37.7526 5.61333 37.6645 5.57459 37.5678C5.53585 37.4711 5.51668 37.3677 5.5182 37.2635C5.52504 37.1721 5.54154 37.0816 5.56742 36.9936L7.17687 31.1719Z" stroke="#95A7B1" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round"></path>
                        </svg>
                    </div>
                    <div v-if="widget_data.widget.settings.platforms.length == 1">
                        <img v-for="(item, index) in widget_data.widget.settings.listings" :key="index" v-show="listingEnabled(item.id)"
                            :src="getIconUrl(item.url)"
                            class="listing-img"
                        >
                    </div>
                    <div v-else class="-mt-2">
                        <i class="mdi mdi-share-variant-outline" :style="'font-size: 25px; color: ' + widget_data.widget.settings.star_color"></i>
                    </div>
                </div>

                <div class="pl-5 text-lg text-bold" style="display: inline-block; vertical-align: super;">
                    {{ ((widget_data.widget.settings.badge_9_title) ? widget_data.widget.settings.badge_9_title.replace('[reviews_nr]', widget_data.total_reviews).replace('[rating_nr]', widget_data.average_rating) : "Our reviews") }}
                </div>
            </div>

            <div class="clearfix p-1 pt-1">
                <div class="text-center">
                    <v-rating
                        class="reviews-rating"
                        :value="parseFloat(widget_data.average_rating)"
                        :color="widget_data.widget.settings.star_color"
                        dense
                        half-increments
                        readonly
                        size="26"
                    ></v-rating>
                </div>
            </div>

            <div class="clearfix text-md p-2 pt-0 text-center pb-4" v-html="((widget_data.widget.settings.badge_9_subtitle) ? widget_data.widget.settings.badge_9_subtitle.replace('[reviews_nr]', widget_data.total_reviews).replace('[rating_nr]', widget_data.average_rating).replace(/\[bold\]/g, '<strong>').replace(/\[\/bold\]/g, '</strong>') : '<strong>' + widget_data.average_rating + ' </strong> Stars | <strong>' + widget_data.total_reviews +  '</strong> reviews')"></div>
        </v-card>

        <div v-if="widget_data.widget.subscription.stripe_id == 'starter'" class="reviews-footer" :style="'color: ' + widget_data.widget.settings.footer_text_color + '; text-align: center;'">
            Powered by <a href="https://reviewgrower.com/" target="review-grower-external" :style="'color: ' + widget_data.widget.settings.footer_link_color + ';'">Review Grower</a>
        </div>
    </div>
</template>

<script>
import Header from '@/views/panel/Business/Widgets/Render/Header.vue';
import Review from '@/views/panel/Business/Widgets/Render/Review.vue';
import urlParser from 'url-parse'

export default {
    props: ["widget_data", "fw"],

    components: {
        Header,
        Review
    },
    
    methods: {
        getHostname(url) {
            return urlParser(url).hostname.replace("www.", "")
        },
        getPathname(url) {
            return urlParser(url).pathname
        },
        getIconUrl(url) {
            return require('@/assets/images/review-services/www.' + this.getHostname(url) + ".png");
        },
        listingEnabled(id) {
            console.log('id', id);
            console.log('this.widget_data.widget.settings.platforms', this.widget_data.widget.settings.platforms);
            for (var i in this.widget_data.widget.settings.platforms) {
                if (this.widget_data.widget.settings.platforms[i] == id)
                    return true;
            }

            return false;
        }
    }
}
</script>

<style type="text/css" scoped>
    .badge-9-wrapper {
        width: 235px;
        padding-bottom: 10px;
    }

    .listing-img {
        width: 24px;
        height: 24px;
        border-radius: 50%;
    }
</style>